'use strict';
var navTreeService = function() {
  this.navTree={};
};
angular.module('app').service('navTreeService',[navTreeService]);
